import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { PurchaseCheckData } from '../CampaignEditorState';

export const useSetPurchaseCheckAll = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (purchaseCheck: PurchaseCheckData) => {
      dispatch({ type: 'SET_PURCHASE_CHECK_ALL', payload: purchaseCheck });
    },
    [dispatch],
  );
};
